import type * as React from "react";
import { type FC, useCallback, useEffect, useState } from "react";

import { TextField } from "~/common/mui";
import { sendResetPasswordRequest } from "~/features/auth/login/api/ResetPassword";
import { useTranslation } from "react-i18next";

interface Props {
  initialEmail?: string;
  onSuccess: (globalErrors: string[]) => void;
  disableEdit?: boolean;
}

const EMAIL_FIELD_NAME = "email";

const ResetPasswordForm: FC<Props> = ({ initialEmail, onSuccess, disableEdit }) => {
  const { t } = useTranslation();

  const [validationError, setValidationError] = useState("");

  const [email, setEmail] = useState(initialEmail ?? "");

  useEffect(() => {
    setEmail(initialEmail ?? "");
  }, [initialEmail]);

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };
  const onSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();

      try {
        const data = await sendResetPasswordRequest(email);
        const requestHasErrors =
          data.validationResults[EMAIL_FIELD_NAME] || (data.globalErrors && data.globalErrors.length > 0);
        if (requestHasErrors) {
          if (data.validationResults[EMAIL_FIELD_NAME]) {
            setValidationError(data.validationResults[EMAIL_FIELD_NAME][0]);
          }
        } else {
          onSuccess(data.globalErrors);
        }
      } catch (err) {
        if (err instanceof Error) {
          setValidationError(err.message);
        }
      }
    },
    [email, onSuccess],
  );

  return (
    <>
      <form id="reset-password" onSubmit={onSubmit} style={{ width: "100%" }}>
        <TextField
          fullWidth
          label={t("email.address.label")}
          inputProps={{ "data-test-id": "reset-email-input" }}
          name={EMAIL_FIELD_NAME}
          value={email}
          onChange={onEmailChange}
          error={!!validationError}
          helperText={t(validationError)}
          disabled={disableEdit}
        />
      </form>
    </>
  );
};

export default ResetPasswordForm;
